import React, { useEffect, useState } from "react";
import "./plantSettings.css";
import Tabs from "../../Components/Tabs/Tabs";
import { plantSettingsMap, plantSettingsTabs } from "../../Utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { getRolesList } from "../../API-Interaction/apiServices/roles.api";

const PlantSettings = () => {


  const dispatch = useDispatch()
  const { current } = useSelector(state => state.plant)
  const { component } = useSelector(state => state.utils.reloadFlags)
  useEffect(() => {
    current?.plant && getRolesList(dispatch, current)
  }, [current, component.roles])

  return (
    <div className="dflex flexColumn gap20 p20">
      <h1 className="pageHead">Plant Settings</h1>
      <Tabs map={plantSettingsMap} tabsData={plantSettingsTabs} />
    </div>
  );
};

export default PlantSettings;
